export default __webpack_public_path__ + "static/media/files_generic.9123374b.png";